<template>
	<div>
		<CountryRegionListItem
			v-if="shouldShowSummaryItem"
			class="country-item-list__item"
			:item="summaryItem"
			:currency="currency"
			is-summary
		/>
		<CountryRegionListItem
			v-for="item in region.Regions"
			:key="item.RegionID"
			class="country-item-list__item"
			:item="item"
			:currency="currency"
		/>
	</div>
</template>

<script lang="ts" setup>
import { defineProps, computed } from 'vue';
import CountryRegionListItem from '@lmt-rpb/CountryRegionListItem/CountryRegionListItem.vue';
import { MOST_POPULAR_REGION_ID } from '@global-js/constants';
import { type RegionItem } from '@/interfaces/region-item';

interface Props {
	region: RegionItem;
	currency: string;
	hotelSummary: Record<string, number>;
	bestPrices: Record<string, number>;
}

const props = defineProps<Props>();

const summaryItem = computed(() => {
	return {
		Name: 'Alle Hotels',
		HotelCount: props.hotelSummary[props.region.code],
		Price: props.bestPrices[props.region.code],
		PriceLabel: 'Gesamtpreis ab',
		URL: props.region.RegionGroupURL
	};
});

const shouldShowSummaryItem = computed(() => props.region.Regions.length > 1 && props.region.RegionGroupID !== MOST_POPULAR_REGION_ID);

</script>

<style lang="scss" scoped>
.country-item-list__item {
	padding: 1rem;
	background: $color-white;
	color: $color-text;
	border-top: 0.1rem solid $color-primary-l4;

	&:first-of-type {
		border-top: 0;
	}
}
</style>
